import React, { forwardRef } from "react";

import { ITitleProps } from "./Title1";
import { ITypographyProps, Typography } from "../Typography";

export const Title2 = forwardRef<
  HTMLDivElement,
  ITitleProps & Omit<ITypographyProps, keyof ITitleProps | "variant">
>(({ weight = "light", children, ...props }, ref) => {
  return (
    <Typography weight={weight} variant="Title 2" ref={ref} {...props}>
      {children}
    </Typography>
  );
});

Title2.displayName = "Title2";
